import kashierLedger from "../../../../../fixtures/dev/payments-ledger-sync/recon.kashier_ledger.mapping.json"
import paymobLedger from "../../../../../fixtures/dev/payments-ledger-sync/recon.paymob_ledger.mapping.json"
import type { SyncSpec } from "../promote"

/**
 * The syncs the payments workbook promotes: MappingIR generated by the Norn TypeScript SDK from
 * tools/norn-ts/fixtures/payments-ledger-sync (golden-tested and admitted by the Rust checker in
 * CI). Each proposes the ERPNext Payment Entries and fee Journal Entry lines its provider's files
 * imply; nothing is written to ERPNext until an administrator installs it and a person approves.
 */
export const PAYMOB_SYNC: SyncSpec = {
  syncId: "paymob-erpnext-ledger",
  sourceSystem: "Paymob",
  targetSystem: "ERPNext",
  mapping: paymobLedger as Record<string, unknown>,
  source: "tools/norn-ts/fixtures/payments-ledger-sync/recon.paymob_ledger.mapping.ts",
}

export const KASHIER_SYNC: SyncSpec = {
  syncId: "kashier-erpnext-ledger",
  sourceSystem: "Kashier",
  targetSystem: "ERPNext",
  mapping: kashierLedger as Record<string, unknown>,
  source: "tools/norn-ts/fixtures/payments-ledger-sync/recon.kashier_ledger.mapping.ts",
}
